




import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  middleware: ['noauth'],
  computed: {
    ...mapState('lang', {
      locale: 'locale',
    }),
  },
})
export default class Redirect extends Vue {
  locale: string;

  mounted () {
    // Redirect to the mobile app page (on mobile it should open store first)
    const locale = this.$store.state.lang.locale;
    return this.$router.push(`/${locale}/onpiste-app`);
  }
}
